import PersonIcon from "@mui/icons-material/Person";
import StarsIcon from "@mui/icons-material/Stars";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dashboardStyles from "./Dashboard.styles";

interface CustomProps {
  onProfilesClick: Function;
}

const WelcomeScreen = (props: CustomProps) => {
  const classes = dashboardStyles;
  const { t } = useTranslation();

  return (
    <Box sx={classes.welcomeBoxWrapper}>
      <Box sx={classes.welcomeBox}>
        <StarsIcon sx={{ color: "#320462", fontSize: "150px" }} />
        <Typography sx={classes.welcomeHeader}>
          {t("welcomeDashboard")}
        </Typography>
        <Typography sx={classes.selectUserText}>
          {t("welcomeDashboardText")}
        </Typography>

        <Button
          onClick={() => props.onProfilesClick()}
          startIcon={<PersonIcon />}
          sx={classes.preferenceBtn}
        >
          <Typography sx={classes.preferenceBtnText}>
            {t("profiles")}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default WelcomeScreen;
